import { render, staticRenderFns } from "./LPXYYEBP.vue?vue&type=template&id=dd386ff0&scoped=true"
import script from "./LPXYYEBP.vue?vue&type=script&lang=js"
export * from "./LPXYYEBP.vue?vue&type=script&lang=js"
import style0 from "./LPXYYEBP.vue?vue&type=style&index=0&id=dd386ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd386ff0",
  null
  
)

export default component.exports